
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { component as Viewer } from 'v-viewer';
import { BASE_URL } from '@/common/constant';
import { $delay } from '@/common/utils';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import SupplyService from '@/services/supply.service';

@Component({
  components: {
    Viewer,
  },
})
export default class ConfirmPaymentModal extends Vue {
  visible = false;

  loading = false;

  uploading = false;

  record: any = null;

  BASE_URL = BASE_URL;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  token: string | undefined = undefined;

  fileList: any[] = [];

  form: any = {
    fileList: [] as any[],
  };

  rules: any = {
    fileList: [
      {
        required: true,
        validator: (_rule: any, _value: any, callback: any) => {
          console.log('验证上款凭证', _value);
          if (!_value.length) {
            callback(new Error('请上传上款凭证'));
          } else {
            callback();
          }
        },
        trigger: 'change',
      },
    ],
  };

  @Ref('ruleForm')
  private ruleForm!: FormModel;

  @lazyInject(UserService)
  userService!: UserService;

  created() {
    this.token = this.userService.currentUser()?.token;
  }

  open(record: any) {
    this.record = record || null;
    this.fileList = [];
    this.form = { fileList: [] };
    this.visible = true;
    this.$nextTick(() => {
      this.ruleForm && this.ruleForm.clearValidate('');
    });
  }

  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于 5MB!');
    }
    return isJpgOrPng && isLt5M;
  }

  async onUploadChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
      return;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response || {};
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: { redirect: this.$route.fullPath },
        });
      } else {
        this.$message.error(error || '上传失败');
      }
      return;
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      this.form.fileList.push({
        id: data[0]?.id,
        uid: data[0]?.id,
        url: data[0]?.url,
        name: 'voucher.png',
        status: 'done',
      });
      this.uploading = false;
      this.ruleForm && this.ruleForm.clearValidate('fileList');
    }
  }

  delVoucher(index: number) {
    this.form.fileList.splice(index, 1);
  }

  handleOk() {
    console.log('确认收款', this.form.fileList);
    this.ruleForm.validate(async (valid) => {
      if (!valid) {
        return false;
      }
      this.loading = true;
      // TODO: 调用平台销售单确认收款接口，参数示例：
      // { id: this.record.id, receiptVoucherImg: this.fileList.map(f => f.id).join(',') }
      const ids = this.form.fileList.map((f: any) => f.id);
      const params = {
        order_no: this.record.orderNo,
        resource_no: ids,
      };
      console.log('确认收款上传上款凭证', params);
      const res = await this.supplyService.postConfirmReceipt(params);
      if (res) {
        this.$message.success('确认收款成功');
        this.loading = false;
        this.visible = false;
        this.$emit('refresh');
      }
    });
  }

  handleCancel() {
    this.visible = false;
    this.form.fileList = [];
    if (this.ruleForm) {
      this.ruleForm.resetFields();
    }
  }
}
